import { BODY_SM_SM_MEDIUM_STYLES, BODY_SM_SM_STYLES } from '@constants/text.ts';
import styled from 'styled-components';

export const DescriptionWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const Description = styled.div`
    color: var(--colors-text-body, #50566e);
    ${BODY_SM_SM_STYLES};

    ul {
        padding-inline-start: 24px;
        margin-block-end: 0;
    }
`;

export const Actions = styled.div`
    display: flex;
    gap: 16px;
    flex-wrap: wrap;

    button {
        span {
            ${BODY_SM_SM_MEDIUM_STYLES};
        }
    }
`;
